// Helper function to convert aspect ratio string to number when needed for calculations
export const parseAspectRatio = (aspectRatioString: string): number => {
  const [width, height] = aspectRatioString.split('/').map(Number);
  return width / height;
};
